<template>
    <form>
        <div class="vx-row mb-2">
            <div class="vx-col w-full lg:w-1/2 mb-2">
                <div class="m-2" v-show="!isEditingCompany"><span class="text-danger">* </span><span>CPF</span></div>
                <vs-input size="large" name="CPF do proprietário" class="w-full" icon-pack="feather" icon="icon-book" v-model="form.document_number" v-mask="['###.###.###-##']" v-validate="'required'"/>
                <span class="text-danger text-sm" v-show="errors.has('CPF do proprietário') && !isEditingCompany">{{ errors.first('CPF do proprietário') }}</span>
            </div>
            <div class="vx-col w-full lg:w-1/2">
                <div class="m-2" v-show="!isEditingCompany"><span class="text-danger">* </span><span>Nome do Proprietário</span></div>
                <vs-input icon-pack="feather" icon="icon-user" size="large" class="w-full" v-model="form.name" name="Nome do propriétario" v-validate="'required'"/>
                <span class="text-danger text-sm"  v-show="errors.has('Nome do propriétario') && !isEditingCompany">{{ errors.first('Nome do propriétario') }}</span>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="vs-row m-2" v-show="!isEditingCompany"><span class="text-danger">* </span><span>Qual o sexo do proprietário(a)?</span></div>
                <div class="vs-row mt-4 mb-2">
                    <vs-radio class="mr-4" v-model="form.gender" :vs-value="gender.id" v-for="(gender, index) in getGender()" :key="index" v-validate="'required'">{{gender.name}}</vs-radio>
                </div>
                <span class="text-danger text-sm" v-show="onValidation && !form.gender && !isEditingCompany">O campo sexo é obrigatório</span>
            </div>
            <div class="vx-col mb-2 w-full lg:w-1/2 mb-2">
                <div class="m-2" v-show="!isEditingCompany"><span class="text-danger">* </span><span>Data de Nascimento</span></div>
                <datePicker format="DD-MM-YYYY" class="w-full" placeholder="Selecione a data" v-model="form.born_date" v-validate="'required'"></datePicker>
                <span class="text-danger text-sm" v-show="onValidation && !form.born_date && !isEditingCompany">O campo data de nascimento é obrigatório</span>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-full lg:w-1/2 mb-2">
                <div class="m-2"><span class="text-danger">* </span><span>Celular/WhatsApp</span></div>
                <vs-input v-validate="'required'" name="Celular/WhatsApp" size="large" icon="phone_iphone" class="w-full" v-model="form.contact.phone" v-mask="['(##) # ####-####', '(###) # ####-####']"/>
                <span class="text-danger text-sm" v-show="errors.has('Celular/WhatsApp') && !isEditingCompany">{{ errors.first('Celular/WhatsApp') }}</span>
            </div>
            <div class="vx-col w-full lg:w-1/2">
                <div class="m-2"><span>Telefone Fixo</span></div>
                <vs-input size="large" class="w-full" icon-pack="feather" name="Telefone Fixo" icon="icon-phone" v-model="form.contact.telphone" v-mask="['(##) ####-####']"/>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full mb-2">
                <div class="m-2" v-show="!isEditingCompany"><span class="text-danger">* </span><span>Email</span></div>
                <vs-input size="large" class="w-full" icon-pack="feather" icon="icon-mail" v-model="form.contact.email" name="email" v-validate="'required|email'"/>
                <span class="text-danger text-sm"  v-show="errors.has('email') && !isEditingCompany">{{ errors.first('email') }}</span>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col mb-2 w-full mb-2">
                <span class="vx-col">A senha de acesso será criada no primeiro acesso ao sistema</span>
            </div>
        </div>
    </form>
</template>

<script>
import datePicker from '../../components/datePicker/datePicker'
export default {
    components: {
        datePicker
    },
    props: {
        owner: Object,
        isEditingCompany: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            form: {
                contact: {}
            },
            onValidation: false
        }
    },
    methods: {
        getGender () {
            return [
                {name: 'Masculino', id:'m'},
                {name: 'Feminino', id:'f'},
            ]
        },

        async validateForm () {
            this.onValidation = true;
            return this.$validator.validateAll().then(result => {
                if (result) {
                    return true;
                } else {
                    return false;
                }
            });
        },

        getForm () {
            return this.form;
        },
    },

    created () {
        this.form = this.owner || this.form;
    }
}
</script>

<style>
    .datePickerStyle {
        height: 50px;
    }
</style>

